// extracted by mini-css-extract-plugin
module.exports = {"form":"contract-form_form__2Ijtb","actions":"contract-form_actions__1lkG7"};